import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-[#0A0A0F] py-12 px-4" data-id="element-104">
      <div className="max-w-2xl mx-auto" data-id="element-105">
        <div className="bg-[#16161F] border border-[#FF6B00] rounded-2xl p-6 sm:p-8 text-center" data-id="element-106">
          <span className="text-5xl mb-3 block" data-id="element-107">🛡️</span>

          <h2 className="text-xl sm:text-2xl font-black text-white mb-3" data-id="element-108">
            Garantía{' '}
            <span className="text-[#FF6B00]" data-id="element-109">7 días sin preguntas</span>
          </h2>

          <p className="text-[#B0B0C0] text-sm mb-3 max-w-md mx-auto" data-id="element-110">
            Abrí los 6 tomos. Revisá los 6 bonos. Usálos en tu clase.
          </p>

          <p className="text-white text-base sm:text-lg font-bold mb-1" data-id="element-111">
            Si no es lo que esperabas → 100% de devolución.
          </p>

          <p className="text-[#B0B0C0] text-sm mb-4" data-id="element-112">
            Sin preguntas. Sin formularios. Sin drama.
          </p>

          <span className="text-[#FFD700] text-xs font-bold bg-[#FFD700]/10 px-3 py-1 rounded-full" data-id="element-113">
            Tasa de devoluciones menor al 1%
          </span>
        </div>
      </div>
    </section>;
}